// Company awards and recognition. Used by the About page and, through
// ./micro-data/awards.js, by the Organization schema markup.
// The 2026 to 2024 groups are shown on the page; older years sit under
// "Earlier recognition" (see RECENT_AWARD_YEARS).
export const RECENT_AWARD_YEARS = ['2026', '2025', '2024'];

export const AWARDS = [
  {
    year: '2026',
    awards: [
      { name: '2026 Top Freight Brokerage, Transport Topics' },
      { name: '2026 Logistics IT Top 100, Inbound Logistics' },
      {
        name: '2026 FreightTech 100, FreightWaves',
        link: 'https://www.freightwaves.com/news/freightwaves-announces-2026-freighttech-100-companies',
      },
    ],
  },
  {
    year: '2025',
    awards: [
      {
        name: '2025 FreightTech 100, FreightWaves',
        link: 'https://www.freightwaves.com/news/freightwaves-announces-2025-freighttech-100-companies',
      },
      { name: '2025 Top Workplaces, Chicago Tribune' },
    ],
  },
  {
    year: '2024',
    awards: [
      { name: '2024 Top 100 Logistics IT Providers, Inbound Logistics' },
      {
        name: '2024 Top Food Chain Technology, Food Shippers of America',
        link: 'https://blog.loadsmart.com/loadsmart-wins-food-shippers-of-americas-top-food-chain-technology-award',
      },
      {
        name: '2024 Women in Supply Chain Rising Star, Supply and Demand Chain Executive',
        link: 'https://blog.loadsmart.com/danielle-shuey-2024-women-in-supply-chain',
      },
      {
        name: '2024 Pros To Know, Supply and Demand Chain Executive',
        link: 'https://blog.loadsmart.com/robb-porter-2024-pros-to-know-shippers',
      },
      { name: "2024 Fast 50, Crain's Chicago Business" },
      {
        name: '2024 CityLIGHTS, 1871 Chicago',
        link: 'https://www.youtube.com/watch?v=wUGBHti_ZBs',
      },
      {
        name: '2024 BIG Innovation Award, Business Intelligence Group',
        link: 'https://blog.loadsmart.com/loadsmart-wins-2024-big-innovation-award',
      },
    ],
  },
  {
    year: '2023',
    awards: [
      {
        name: '2023 Top Food Chain Technology, Food Shippers of America',
        link: 'https://blog.foodshippers.org/2023-top-food-chain-technology-list-announced-by-fsas-food-chain-digest',
      },
      {
        name: '2023 Best Newcomer Americas, SS&C Blue Prism',
        link: 'https://www.blueprism.com/customers/awards/',
      },
      {
        name: '2023 Top 10 Freight Brokerage Service Provider, Logistics & Transportation Review',
        link: 'https://www.logisticstransportationreview.com/loadsmart',
      },
    ],
  },
  {
    year: '2022',
    awards: [
      {
        name: '2022 Technology Fast 500 (#214), Deloitte',
        link: 'https://blog.loadsmart.com/2022/11/16/loadsmart-ranked-number-214th-fastest-growing-company-in-north-america-on-the-2022-deloitte-technology-fast-500',
      },
      {
        name: '2022 Excellence in Engineering Operations, Illuminate',
        link: 'https://www.youtube.com/watch?v=XHM_jeQebqE',
      },
      {
        name: '2022 Excellence in Service Award, ISO Technologies',
        link: 'https://www.iso.io/blog/iso-awards/',
      },
      { name: '2022 FreightTech 100, FreightWaves' },
      {
        name: '2022 FreightTech 25 (#16), FreightWaves',
        link: 'https://www.freightwaves.com/news/freighttech-25',
      },
      { name: '2022 Inc. 5000 (No. 881), Inc.' },
      {
        name: "2022 America's Best Startup Employers, Forbes",
        link: 'https://www.forbes.com/lists/americas-best-startup-employers/?sh=2fb4b27b2ad7',
      },
      {
        name: '2022 Entrepreneur of the Year Midwest Finalists (founders), EY',
        link: 'https://www.ey.com/en_us/news/2022/04/ey-announces-eoy-2022-midwest-finalists',
      },
    ],
  },
  {
    year: '2021',
    awards: [
      {
        name: '2021 Entrepreneur of the Year Midwest Finalists (founders), EY',
        link: 'https://www.ey.com/en_us/news/2021/06/ey-eoy-2021-midwest-finalists',
      },
    ],
  },
  {
    year: '2020',
    awards: [
      { name: '2020 Top 25 Companies Disrupting Freight (#18), FreightWaves' },
      { name: '2020 Entrepreneur Of The Year New York Award Finalist, EY' },
      {
        name: '2020 AI 100, CB Insights',
        link: 'https://www.cbinsights.com/research/artificial-intelligence-top-startups-2020/',
      },
    ],
  },
  {
    year: '2019',
    awards: [
      { name: '2019 Top 25 Companies Disrupting Freight (#15), FreightWaves' },
      {
        name: '2019 Automated On-Demand Freight Brokerage Company of the Year, Frost and Sullivan',
        link: 'https://www.prnewswire.com/news-releases/loadsmarts-automated-freight-brokerage-system-awarded-company-of-the-year-by-frost--sullivan-300793548.html',
      },
    ],
  },
  {
    year: '2018',
    awards: [
      { name: '2018 Top 25 Companies Disrupting Freight (#22), FreightWaves' },
      {
        name: '2018 125 Startups Disrupting the Supply Chain, CB Insights',
        link: 'https://blog.loadsmart.com/2018/09/06/cb-insights-selects-loadsmart-as-startup-disrupting-the-supply-chain-logistics-industry',
      },
      {
        name: '2018 Cool Vendor in Intelligent Supply Chain Execution Technologies, Gartner',
        link: 'https://www.globenewswire.com/en/news-release/2018/09/10/1568811/0/en/Loadsmart-named-a-Cool-Vendor-by-Gartner-in-Cool-Vendors-Intelligent-Supply-Chain-Execution-Technologies-by-Gartner.html',
      },
    ],
  },
  {
    year: '2017',
    awards: [
      { name: '2017 Interaction Design (UX) Award, DOGA Oslo, Norway' },
      {
        name: '2017 Most Innovative Tech Company of the Year, Stevie Awards',
        link: 'https://blog.loadsmart.com/2017/05/02/loadsmart-honored-by-aba-with-2017-stevie-award',
      },
    ],
  },
];
